import React from "react";
import AuthLayout from "./AuthLayout";
import { SessionField, SubmitButton } from "./AuthFields";

const ForgotPasswordPage = ({ action, newUserSessionPath, showBackToSignIn }) => (
  <AuthLayout
    action={action}
    showBackToSignIn={showBackToSignIn}
    newUserSessionPath={newUserSessionPath}
  >
    <div>
      <SessionField
        type="email"
        name="user[email]"
        id="user_email"
        placeholder="Email"
        autoComplete="email"
        autoFocus
      />
    </div>
    <div className="mtm">
      <SubmitButton value="Reset Password" />
    </div>
  </AuthLayout>
);

export default ForgotPasswordPage;
